import { useProductViewCommon } from '@/hooks/useProductViewCommon';
import { useProductViewDataSource } from '@/hooks/useProductViewDataSource';
import { ProductViewHook } from '@/types/product-view-model';
import { ProductViewModes } from '@/utils/productStateUtils';

export function useProductChangeRequestRO(): ProductViewHook {
  const dataSource = useProductViewDataSource(
    ProductViewModes.ChangeRequestReadOnly
  );
  return useProductViewCommon(dataSource);
}
